/* VIDA - Pagina de producto: galeria (swipe, zoom, lightbox), variantes, cantidad y barra de compra fija */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  function init(root) {
    var pdp = (root || document).querySelector('[data-pdp]');
    if (!pdp || pdp.hasAttribute('data-ready')) return;
    pdp.setAttribute('data-ready', '');

    /* ---------- Galeria ---------- */
    var track = pdp.querySelector('[data-gal-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.v-gal__slide')) : [];
    var thumbs = Array.prototype.slice.call(pdp.querySelectorAll('[data-thumb]'));
    var dotsWrap = pdp.querySelector('[data-gal-dots]');
    var dots = [];
    var cur = 0;

    function behavior() { return reduce.matches ? 'auto' : 'smooth'; }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: behavior() });
    }
    function setActive(i) {
      cur = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      slides.forEach(function (s, k) {
        s.classList.toggle('is-current', k === i);
        if (k !== i) { var v = s.querySelector('video'); if (v && !v.paused) v.pause(); }
      });
    }
    if (track && slides.length) {
      if (dotsWrap) {
        slides.forEach(function (s, i) {
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'v-gal__dot'; d.setAttribute('aria-label', 'Ir a la imagen ' + (i + 1));
          d.addEventListener('click', function () { goTo(i); });
          dotsWrap.appendChild(d); dots.push(d);
        });
      }
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var w = track.clientWidth || 1;
          setActive(Math.round(track.scrollLeft / w));
        });
      }, { passive: true });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      var prev = pdp.querySelector('[data-gal-prev]'), next = pdp.querySelector('[data-gal-next]');
      if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
      if (next) next.addEventListener('click', function () { goTo(cur + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(cur + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(cur - 1); }
      });
      setActive(0);
    }

    /* ---------- Zoom con el cursor (solo punteros finos) ---------- */
    if (fine.matches && !reduce.matches) {
      pdp.querySelectorAll('[data-zoom]').forEach(function (z) {
        z.addEventListener('pointerenter', function () { z.classList.add('is-zooming'); });
        z.addEventListener('pointermove', function (e) {
          var r = z.getBoundingClientRect();
          z.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          z.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
          var img = z.querySelector('img'); if (img) { img.style.setProperty('--zx', z.style.getPropertyValue('--zx')); img.style.setProperty('--zy', z.style.getPropertyValue('--zy')); }
        });
        z.addEventListener('pointerleave', function () { z.classList.remove('is-zooming'); });
      });
    }

    /* ---------- Lightbox ---------- */
    var lb = pdp.querySelector('[data-lightbox]');
    var zooms = Array.prototype.slice.call(pdp.querySelectorAll('[data-zoom]'));
    var lbImg = lb && lb.querySelector('[data-lb-img]');
    var lbIdx = 0;
    function lbShow(i) {
      lbIdx = (i + zooms.length) % zooms.length;
      lbImg.src = zooms[lbIdx].getAttribute('data-full');
      lbImg.alt = zooms[lbIdx].querySelector('img') ? zooms[lbIdx].querySelector('img').alt : '';
      lbImg.style.animation = 'none'; void lbImg.offsetWidth; lbImg.style.animation = '';
    }
    if (lb && zooms.length) {
      zooms.forEach(function (z, i) {
        z.addEventListener('click', function () {
          lbShow(i);
          if (typeof lb.showModal === 'function') lb.showModal(); else lb.setAttribute('open', '');
          document.body.classList.add('v-lock');
        });
      });
      function lbClose() { if (lb.close) lb.close(); else lb.removeAttribute('open'); document.body.classList.remove('v-lock'); }
      lb.querySelector('[data-lb-close]').addEventListener('click', lbClose);
      lb.querySelector('[data-lb-prev]').addEventListener('click', function () { lbShow(lbIdx - 1); });
      lb.querySelector('[data-lb-next]').addEventListener('click', function () { lbShow(lbIdx + 1); });
      lb.addEventListener('close', function () { document.body.classList.remove('v-lock'); goTo(parseInt(zooms[lbIdx].getAttribute('data-index'), 10) || 0); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') lbShow(lbIdx - 1);
        if (e.key === 'ArrowRight') lbShow(lbIdx + 1);
      });
      var sx = null;
      lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (sx == null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 50) lbShow(lbIdx + (dx < 0 ? 1 : -1));
      });
    }

    /* ---------- Cantidad ---------- */
    var qty = pdp.querySelector('.v-qty__input');
    function clamp() { var v = parseInt(qty.value, 10); if (isNaN(v) || v < 1) v = 1; if (v > 99) v = 99; qty.value = v; }
    if (qty) {
      pdp.querySelector('[data-qty-minus]').addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) - 1; clamp(); });
      pdp.querySelector('[data-qty-plus]').addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; clamp(); });
      qty.addEventListener('change', clamp);
    }

    /* ---------- Columnas: la mas corta queda fija mientras se recorre la mas larga (sin huecos en blanco) ---------- */
    (function () {
      var grid = pdp.querySelector('.v-pdp__grid');
      var galEl = pdp.querySelector('.v-gal--grid');
      var infoEl = pdp.querySelector('.v-info');
      if (!grid || !galEl || !infoEl) return;
      function fit() {
        if (window.innerWidth < 990) { grid.classList.remove('is-gal-sticky'); return; }
        var avail = window.innerHeight - 104;
        grid.classList.toggle('is-gal-sticky', galEl.offsetHeight + 8 < infoEl.offsetHeight && galEl.offsetHeight <= avail);
      }
      fit();
      window.addEventListener('resize', fit);
      window.addEventListener('load', fit);
      pdp.addEventListener('click', function () { setTimeout(fit, 450); });
    })();

    /* ---------- Variantes ---------- */
    var form = pdp.querySelector('[data-buy-form]');
    var vjson = pdp.querySelector('[data-variants]');
    var variants = vjson ? JSON.parse(vjson.textContent) : [];

    /* ---------- Packs 1 / 2 / 3 (el descuento real lo aplica la tienda; aqui solo se muestra el total) ---------- */
    var packs = pdp.querySelector('[data-packs]');
    var packCents = null;
    function money(c) { return '$' + Math.round(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
    function renderPacks(cents) {
      if (!packs) return;
      if (cents != null) packCents = cents;
      if (packCents == null) return;
      var pct = { 1: 0, 2: parseFloat(packs.getAttribute('data-p2')) || 0, 3: parseFloat(packs.getAttribute('data-p3')) || 0 };
      var byVariant = packs.hasAttribute('data-packs-variants') && variants.length >= 3;
      [1, 2, 3].forEach(function (n) {
        var total = packCents * n * (1 - pct[n] / 100);
        if (byVariant) {
          /* Packs con precio propio: el total sale de la variante de 1, 2 o 3 unidades */
          total = variants[n - 1].cents;
          var bd = packs.querySelector('[data-pack-badge="' + n + '"]');
          if (bd) {
            var off = Math.round((1 - total / (variants[0].cents * n)) * 100);
            bd.textContent = '-' + off + '%'; bd.hidden = off <= 0;
          }
        }
        var t = packs.querySelector('[data-pack-total="' + n + '"]'), u = packs.querySelector('[data-pack-unit="' + n + '"]');
        if (t) t.textContent = money(total);
        if (u) u.textContent = n > 1 ? money(total / n) + ' c/u' : '';
      });
    }
    if (packs) {
      var curV = variants.filter(function (v) { return String(v.id) === String(form.querySelector('[data-variant-id]').value); })[0] || variants[0];
      if (curV) renderPacks(curV.cents);
      packs.addEventListener('change', function (e) {
        if (!(e.target && e.target.type === 'radio')) return;
        if (packs.hasAttribute('data-packs-variants') && variants.length >= 3) {
          /* Cada pack es una variante distinta (1, 2 o 3 unidades) y la cantidad queda en 1 */
          var target = variants[parseInt(e.target.value, 10) - 1];
          if (!target) return;
          if (qty) { qty.value = 1; clamp(); }
          var opt = form.querySelector('.v-opt input[value="' + String(target.options[0]).replace(/"/g, '\\"') + '"]');
          if (opt) { opt.checked = true; opt.dispatchEvent(new Event('change', { bubbles: true })); }
          else applyVariant(target);
          return;
        }
        if (qty) { qty.value = e.target.value; clamp(); }
      });
    }
    var cta = pdp.querySelector('.v-buy__cta');
    var stickyBtn = pdp.querySelector('[data-sticky-add]');
    var ctaLabelAvail = cta ? cta.querySelector('[data-label]').textContent : 'Comprar ahora';
    var addBtn = pdp.querySelector('.v-buy__add');
    var addLabelAvail = addBtn ? addBtn.querySelector('[data-label]').textContent : 'Agregar al carrito';
    var stickyLabelAvail = stickyBtn && stickyBtn.querySelector('[data-label]') ? stickyBtn.querySelector('[data-label]').textContent : 'Comprar';

    function setLabel(btn, text) {
      if (!btn) return; var s = btn.querySelector('[data-label]'); if (s) { s.textContent = text; btn._orig = text; }
    }
    // El dato nuevo (precio) entra con un fundido corto: confirma que el cambio de variante tuvo efecto sin llamar la atencion
    function fadeText(el, text) {
      if (!el || el.textContent === text) return;
      if (reduce.matches) { el.textContent = text; return; }
      el.classList.add('is-swap');
      setTimeout(function () { el.textContent = text; el.classList.remove('is-swap'); }, 220);
    }
    function applyVariant(v) {
      form.querySelector('[data-variant-id]').value = v.id;
      fadeText(pdp.querySelector('[data-price]'), v.price);
      renderPacks(v.cents);
      var cmp = pdp.querySelector('[data-compare]'), dsc = pdp.querySelector('[data-discount]');
      if (v.compare) { cmp.textContent = v.compare; cmp.hidden = false; dsc.textContent = '-' + v.discount + '%'; dsc.hidden = false; }
      else { cmp.hidden = true; dsc.hidden = true; }
      var stock = pdp.querySelector('[data-stock]');
      stock.innerHTML = v.available ? '<span class="v-stock__dot"></span> Disponible' : '<span class="v-stock__dot v-stock__dot--off"></span> Agotado por ahora';
      [cta, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !v.available;
        setLabel(b, v.available ? (b === cta ? ctaLabelAvail : stickyLabelAvail) : 'Agotado');
      });
      if (addBtn) { addBtn.disabled = !v.available; setLabel(addBtn, v.available ? addLabelAvail : 'Agotado'); }
      var sp = pdp.querySelector('[data-sticky-price]'); if (sp) fadeText(sp, v.price);
      var ss = pdp.querySelector('[data-sticky-stock]'); if (ss) ss.textContent = v.available ? 'Disponible' : 'Agotado';
      if (v.media) {
        var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(v.media); });
        if (idx > -1) goTo(idx);
      }
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u); } catch (e) { /* noop */ }
    }
    if (form && variants.length > 1) {
      form.addEventListener('change', function (e) {
        if (e.target.type !== 'radio') return;
        var chosen = [];
        form.querySelectorAll('.v-opt').forEach(function (fs) {
          var checked = fs.querySelector('input:checked');
          chosen.push(checked ? checked.value : null);
          var lbl = fs.querySelector('[data-opt-label]'); if (lbl && checked) lbl.textContent = checked.value;
        });
        var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
        var err = form.querySelector('[data-error]');
        if (match) { err.hidden = true; applyVariant(match); }
        else { err.textContent = 'Esa combinación no está disponible.'; err.hidden = false; [cta, stickyBtn, addBtn].forEach(function (b) { if (b) b.disabled = true; }); }
      });
    }

    /* ---------- Comprar ahora: elegir forma de pago (1 tarjeta / 2 contra entrega) ---------- */
    var pay = pdp.querySelector('[data-pay]');
    if (pay) {
      var qtyInput = pdp.querySelector('.v-qty__input');
      var variantInput = form && form.querySelector('[data-variant-id]');
      var codBtn = function () { return document.getElementById('rsi_buy_now_button'); };
      function openPay() {
        var codItem = pay.querySelector('[data-pay-cod-item]');
        if (codItem) codItem.hidden = !codBtn();           // la opcion 2 solo aparece si la app de pago contra entrega esta instalada
        var q = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        var sum = pay.querySelector('[data-pay-sum]');
        var title = pdp.querySelector('.v-info__title');
        if (sum && title) sum.textContent = (q > 1 ? q + ' × ' : '') + title.textContent.trim();
        if (typeof pay.showModal === 'function') { if (!pay.open) pay.showModal(); } else pay.setAttribute('open', '');
        requestAnimationFrame(function () { pay.classList.add('is-open'); });
        var first = pay.querySelector('[data-pay-card]'); if (first) first.focus({ preventScroll: true });
      }
      function closePay() {
        pay.classList.remove('is-open');
        setTimeout(function () { if (pay.close) pay.close(); else pay.removeAttribute('open'); }, reduce.matches ? 0 : 350);
      }
      pdp.querySelectorAll('[data-buy-now]').forEach(function (b) { b.addEventListener('click', function () { if (!b.disabled) openPay(); }); });
      pay.querySelector('[data-pay-close]').addEventListener('click', closePay);
      pay.addEventListener('click', function (e) { if (e.target === pay) closePay(); });
      pay.addEventListener('cancel', function (e) { e.preventDefault(); closePay(); });
      /* 1) Tarjeta: agrega el producto y va directo al checkout de Shopify (navegacion normal, sin fetch) */
      pay.querySelector('[data-pay-card]').addEventListener('click', function () {
        var f2 = document.createElement('form');
        f2.method = 'post'; f2.action = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add');
        [['id', variantInput ? variantInput.value : ''], ['quantity', qtyInput ? qtyInput.value : 1], ['return_to', '/checkout']].forEach(function (kv) {
          var i = document.createElement('input'); i.type = 'hidden'; i.name = kv[0]; i.value = kv[1]; f2.appendChild(i);
        });
        document.body.appendChild(f2); f2.submit();
      });
      /* 2) Contra entrega: abre el formulario de la app de pago contra entrega */
      pay.querySelector('[data-pay-cod]').addEventListener('click', function () {
        closePay();
        setTimeout(function () { var b = codBtn(); if (b) b.click(); }, reduce.matches ? 0 : 380);
      });
    }
    /* ---------- Aviso de envios (abajo a la izquierda): se abre una vez y queda minimizado ---------- */
    var popenv = pdp.querySelector('[data-popenv]');
    if (popenv) {
      document.body.appendChild(popenv);
      var popKey = 'vidaPopEnvioCerrado2', popMin = false;
      try { popMin = sessionStorage.getItem(popKey) === '1'; } catch (e) { /* noop */ }
      // Instagram/WhatsApp quedan justo encima del aviso: se mide su altura (caja abierta o etiqueta minimizada)
      var popOffset = function () {
        var el = popenv.classList.contains('is-open') ? popenv.querySelector('.v-popenv__box') : popenv.querySelector('.v-popenv__pill');
        document.documentElement.style.setProperty('--v-pop-off', ((el ? el.offsetHeight : 40) + 10) + 'px');
      };
      var popShow = function (open) { popenv.classList.toggle('is-open', open); popenv.classList.toggle('is-min', !open); popOffset(); };
      window.addEventListener('resize', popOffset);
      var popSave = function (v) { try { sessionStorage.setItem(popKey, v ? '1' : '0'); } catch (e) { /* noop */ } };
      popenv.hidden = false;
      popenv.querySelector('[data-popenv-close]').addEventListener('click', function () { popShow(false); popSave(true); });
      popenv.querySelector('[data-popenv-open]').addEventListener('click', function () { popShow(true); popSave(false); });
      pdp.querySelectorAll('[data-ship-open]').forEach(function (b) { b.addEventListener('click', function () { popShow(true); popSave(false); }); });
      if (popMin) popShow(false); else setTimeout(function () {
        popShow(true);
        // en celular el aviso tapa parte de la ficha: se minimiza solo a los 5 segundos
        if (window.innerWidth < 750) setTimeout(function () { if (popenv.classList.contains('is-open')) { popShow(false); } }, 6000);
      }, 2500);
    }
    /* ---------- Accesos flotantes (Instagram / WhatsApp) ---------- */
    var social = pdp.querySelector('[data-social]');
    if (social) document.body.appendChild(social);

    /* ---------- Barra de compra fija ---------- */
    var sticky = pdp.querySelector('[data-sticky]');
    if (sticky && cta && 'IntersectionObserver' in window) {
      sticky.hidden = false; sticky.removeAttribute('aria-hidden');
      /* Sin listener de scroll: solo un IntersectionObserver. Aparece cuando el boton principal salio POR ARRIBA de la pantalla. */
      function setSticky(show) {
        sticky.classList.toggle('is-visible', show);
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      new IntersectionObserver(function (en) {
        var e = en[en.length - 1];
        /* Escritorio y movil: la barra aparece solo cuando el boton "Comprar ahora" ya quedo por ARRIBA de la pantalla (se paso hacia abajo). Mientras se esta arriba de el, no aparece. */
        setSticky(!e.isIntersecting && e.boundingClientRect.bottom < 80);
      }, { rootMargin: '-80px 0px 0px 0px' }).observe(cta);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
